import { useState, type FormEvent } from "react";
import { useAuth } from "../lib/auth";
import { Botao, Campo, MensagemErro } from "../componentes/ui";

export default function Login() {
  const { entrar } = useAuth();
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setOcupado(true);
    setErro(await entrar(usuario, senha));
    setOcupado(false);
  }

  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <form onSubmit={enviar} className="w-full max-w-sm rounded-lg border-2 border-tinta bg-chapa">
        <div className="flex flex-col items-center gap-2 border-b-4 border-faixa px-5 pb-4 pt-6">
          <img src="/logo-oficial.png" alt="Oficial" className="h-16 w-auto" />
          <h1 className="font-sinal text-2xl font-bold">WMS</h1>
        </div>
        <div className="flex flex-col gap-4 p-5">
          <Campo rotulo="Usuário" value={usuario} onChange={(e) => setUsuario(e.target.value)}
            autoComplete="username" autoCapitalize="none" autoFocus required />
          <Campo rotulo="Senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password" required />
          <MensagemErro>{erro}</MensagemErro>
          <Botao type="submit" grande disabled={ocupado}>{ocupado ? "Entrando..." : "Entrar"}</Botao>
        </div>
      </form>
    </div>
  );
}
